'use client';

import { applicationPrefixMap, errorImageVariants, NEXT_PUBLIC_IMAGE_CDN_URL } from '@pickleballinc/lib/constants';
import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { Application } from '@pickleballinc/lib/types';
import { cn } from '@pickleballinc/ui/lib/utils';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

interface ErrorSectionProps {
	title: string;
	description?: string;
	children?: ReactNode;
	themeColor?: string;
	containerClassName?: string;
	titleClassName?: string;
	descriptionClassName?: string;
	customErrorCharacter?: ReactNode;
	application?: Application;
}

export function ErrorSection(props: ErrorSectionProps) {
	const { application = 'pickleball' } = props;

	const imageURL = NEXT_PUBLIC_IMAGE_CDN_URL;

	const [variant, setVariant] = useState<(typeof errorImageVariants)[number]>('404-error-image');

	useEffect(() => {
		setVariant(errorImageVariants[Math.floor(Math.random() * errorImageVariants.length)] ?? '404-error-image');
	}, []);

	const prefix = applicationPrefixMap[application];

	return (
		<div className={cn('w-full flex flex-col items-center justify-start gap-2 overflow-hidden pt-2', props.containerClassName)}>
			{props.customErrorCharacter ? (
				props.customErrorCharacter
			) : (
				<img
					src={getCDNURL(`${imageURL}/global/404-error/${prefix}-${variant}.svg`, 640, 466)}
					alt={`${props.title} - Illustration`}
					className="w-full max-w-[300px]"
				/>
			)}
			<div className="flex flex-col items-center gap-2">
				<h2 className={cn('text-center text-[30px] font-semibold', props.titleClassName)}>{props.title}</h2>
				{props.description ? (
					<p className={cn('text-center text-[20px] text-gray-600', props.descriptionClassName)}>{props.description}</p>
				) : null}
			</div>
			{props.children ? props.children : null}
		</div>
	);
}
